'use strict'

export const AvatarIndicator = {
  props: {
    boxSize: 'fit-content',
    position: 'relative',
    round: '100%'
  },

  Avatar: {},

  StatusIndicator: {
    theme: 'success',
    position: 'absolute',
    bottom: '0',
    right: '0'
  }
}
